import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { Clock, DollarSign, Users, Globe, TrendingUp } from "lucide-react";

const WhySection = () => {
  const { t } = useTranslation('home');

  const reasons = [
    { icon: Users, titleKey: "why.reasons.talent.title", descriptionKey: "why.reasons.talent.description" },
    { icon: DollarSign, titleKey: "why.reasons.cost.title", descriptionKey: "why.reasons.cost.description" },
    { icon: Clock, titleKey: "why.reasons.timezone.title", descriptionKey: "why.reasons.timezone.description" },
    { icon: Globe, titleKey: "why.reasons.culture.title", descriptionKey: "why.reasons.culture.description" },
    { icon: TrendingUp, titleKey: "why.reasons.innovation.title", descriptionKey: "why.reasons.innovation.description" },
  ];

  return (
    <section id="why" className="py-32 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-20 max-w-3xl mx-auto">
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4 font-medium">
            Why Africa
          </p>
          <h2 className="text-4xl md:text-5xl font-bold mb-5 text-balance">
            {t('why.title')}
          </h2>
          <p className="text-lg text-muted-foreground text-balance">
            {t('why.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <Card
                key={index}
                className="group animate-fade-in"
                style={{ animationDelay: `${index * 80}ms` }}
              >
                <CardContent className="p-7">
                  <div className="w-11 h-11 rounded-xl bg-foreground/[0.04] border border-border/60 flex items-center justify-center mb-5 transition-colors group-hover:bg-foreground/[0.08]">
                    <Icon className="w-5 h-5 text-foreground" aria-hidden="true" strokeWidth={1.75} />
                  </div>
                  <h3 className="text-lg font-semibold mb-2 tracking-tight">{t(reason.titleKey)}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {t(reason.descriptionKey)}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhySection;
